import { render } from "./IntentionSetterV1Switch.vue?vue&type=template&id=27d385a6&scoped=true"
import script from "./IntentionSetterV1Switch.vue?vue&type=script&lang=js"
export * from "./IntentionSetterV1Switch.vue?vue&type=script&lang=js"

import "./IntentionSetterV1Switch.vue?vue&type=style&index=0&id=27d385a6&lang=sass&scoped=true"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27d385a6"]])

export default __exports__